import './TabletBlock.css';

export default function TabletBlock(){
    return <>

    <div class="page">
    
    <div class="tabletContainer">
      <div class="center">
        <div class="followTablet">
          <a target="_blank" rel="noreferrer" href="https://www.instagram.com/natural.seducer/">
            <i class="fab fa-instagram"></i><span> Follow Us</span></a>
         </div>  
      </div>  
    </div>
       
     </div>
     </>
     ;
}